import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CreateCategorySchema } from "../../utilities/schemas";
import {
  createCategory,
  updateCategory,
} from "../../redux/slices/categorySlice";
import InputField from "../../components/InputField";
import { useFormik } from "formik";

const NewCategory = () => {
  const dispatch = useDispatch();
  let params = useParams();

  const initialValues = {
    category: "",
    img_url: "aws/mens/url",
  };

  const createCategoryHandler = (data) => {
    const updateDate = { id: params.id, data };
    if (params && params.id) {
      dispatch(updateCategory(updateDate));
    } else {
      dispatch(createCategory(data));
    }
  };

  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues,
    validationSchema: CreateCategorySchema,
    onSubmit: (data) => createCategoryHandler(data),
    enableReinitialize: true,
  });

  return (
    <div className="mt-32 flex flex-col justify-center items-center">
      <p className="text-gray-600 mt-3 mb-8">
        {params?.id ? "Update Category" : "New Category"}
      </p>
      <div className="w-1/2">
        <div className="space-y-4">
          <InputField
            label="Category name"
            id="category"
            type="text"
            value={values.category}
            onChange={handleChange("category")}
            errorMsg={touched.category ? errors.category : undefined}
            placeholder="Accessories"
          />
        </div>
        <div className="mt-4">
          <button
            onClick={() => {
              handleSubmit();
            }}
            className="block w-full py-2 text-center text-primary bg-transparent border border-primary rounded hover:border-gray-300 hover:text-primary transition uppercase font-roboto font-medium text-xs"
          >
            create category
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewCategory;
